<template>
  <PopupBackground v-if="showInvitePopup">
    <div class="popup-card smooth-shadow">
      <div class="block fw">
        <div class="header">
          <div class="flex-expand"></div>
          <i class="material-icons icon-button" @click="toggleInvitePopup()"
            >clear</i
          >
        </div>
      </div>
      <img class="header-image" src="@/assets/user-invites.svg" />

      <h2>Invite members to orgnisation</h2>
      <p>Build, explore and share insights with your collegues</p>
      <div v-if="isInviteInProgress" class="block pad-20">
        <LoadingBar />
      </div>
      <div v-else class="block fw">
        <div class="flex-center mar-top-15 mar-bottom-20">
          <input type="email" v-model="email" :placeholder="'Email Address'" />
          <button class="button mar-left-10" @click="invite()">
            <b>Send Invite</b>
          </button>
        </div>
      </div>
    </div>
  </PopupBackground>
</template>

<script>
import PopupBackground from "@/components/modals/PopupBackground";
import { mapActions, mapGetters } from "vuex";
import { validateEmail } from "@/lib/validations";

export default {
  components: {
    PopupBackground,
  },
  data() {
    return {
      isInviteInProgress: false,
      email: "",
    };
  },
  computed: {
    ...mapGetters("Popup", ["showInvitePopup"]),
  },
  methods: {
    ...mapActions("Popup", ["toggleInvitePopup"]),
    ...mapActions("User", ["sendInvitationLink"]),
    invite() {
      if (validateEmail(this.email)) {
        this.isInviteInProgress = true;
        this.sendInvitationLink(this.email)
          .then(response => {
            this.isInviteInProgress = false;
            if (response.status === 200) {
              this.isInviteInProgress = false;
              this.email = "";
            } else {
              this.isInviteInProgress = false;
            }
          })
          .catch(error => {
            this.isInviteInProgress = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--color-secondary);
  border-radius: 5px;
  width: 500px;

  .header-image {
    width: 300px;
    height: auto;
    margin: 15px;
  }
  .header {
    padding: 10px;
    display: flex;
    flex-direction: row;

    i {
      margin-left: auto;
    }
  }

  h2 {
    font-weight: bold;
    padding: 10px;
  }

  p {
    margin: 0;
    padding: 5px 15px;
    font-size: 1em;
  }
}
</style>
